import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-not-implemented',
  templateUrl: './not-implemented.component.html',
  styleUrls: ['./not-implemented.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotImplementedComponent {}
